import React from "react";

// Il bottone che porta alla community: un semplice link esterno, non un popup.
// L'indirizzo arriva da REACT_APP_COMMUNITY_URL (il link d'invito del canale
// Instagram, es. https://ig.me/j/XXXX) e viene incorporato nel bundle al build.
// La variabile è volutamente generica: se un giorno la community si sposta su
// Telegram o WhatsApp basta cambiare il valore, non il codice.
const COMMUNITY_URL = process.env.REACT_APP_COMMUNITY_URL;

if (!COMMUNITY_URL) {
  // Meglio accorgersene in console che scoprire una CTA morta in produzione.
  console.error(
    "REACT_APP_COMMUNITY_URL non impostata: il bottone della community è disattivato."
  );
}

export default function CommunityButton({ className = "", children, testId }) {
  // Senza indirizzo configurato il bottone resta visibilmente inerte: è preferibile
  // a uno che sembra funzionare e non porta da nessuna parte.
  if (!COMMUNITY_URL) {
    return (
      <button
        type="button"
        disabled
        className={`${className} opacity-40 cursor-not-allowed`}
        title="Community non configurata (REACT_APP_COMMUNITY_URL mancante)"
        data-testid={testId}
      >
        {children}
      </button>
    );
  }

  return (
    <a
      href={COMMUNITY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-testid={testId}
    >
      {children}
    </a>
  );
}
